import { SavedSearchContextProvider } from './saved-search-context'
import { FC } from 'react'
import { ToastContextProvider } from './toast-context'
import { UserLocationContextProvider } from './user-location-context'
import { SavedAdvertsContextProvider } from './saved-adverts-context'
import { combineComponents } from './combine-contexts'
import { SearchViewContextProvider } from './search-view-state-context'
import { PagesLoadedContextProvider } from './pages-loaded-context'

/**
 * This is the list of context providers that will be combined
 * in order from left to right to maintain order and tidyness
 */
const providers = [
    ToastContextProvider,
    UserLocationContextProvider,
    SavedAdvertsContextProvider,
    SavedSearchContextProvider,
    SearchViewContextProvider,
    PagesLoadedContextProvider,
] as FC[]

export const SearchResultsAppContextProvider = combineComponents(...providers)
